export const projects = [
  {
    title: "Sales Call Rule Engine",
    category: "Business Logic",
    summary:
      "Helped develop a rule engine that handled business logic for a multi-company sales call interface.",
    impact:
      "Supported configurable call flows and decision logic across multiple business contexts.",
    stack: ["C#", "React", "Business Rules", "Sales Tools"],
    accent: "#0066CC",
  },
  {
    title: "Project Estimating Model",
    category: "Full Stack",
    summary:
      "Worked on a project estimating model for the same sales application, pairing C# business logic with a React frontend.",
    impact:
      "Helped users create estimates from application data with a clearer, more guided workflow.",
    stack: ["C#", "React", "Estimation", "Workflow UI"],
    accent: "#2E7D32",
  },
  {
    title: "Home Sales Application",
    category: "Application Maintenance",
    summary:
      "Maintained a sales application for selling homes, supporting a JavaScript and Kendo frontend with a .NET 8 backend.",
    impact:
      "Kept a production sales workflow reliable while improving and maintaining both frontend and backend areas.",
    stack: ["JavaScript", "Kendo UI", ".NET 8", "Sales Apps"],
    accent: "#6A4C93",
  },
  {
    title: "ID Scanning Application",
    category: "Integration",
    summary:
      "Created an ID scanning application that used a React frontend and .NET backend to capture ID data.",
    impact:
      "Sent scanned information to LexisNexis to support background-check workflows.",
    stack: ["React", ".NET", "ID Scanning", "LexisNexis"],
    accent: "#C75C2C",
  },
];

export const featuredProjects = projects.slice(0, 3);
